<template>
    <div class="app-wrapper" :class="classObj">
        <el-container>
            <el-aside :width="'unset'">
                <sidebar class="sidebar-container" />
            </el-aside>
            <el-container>
                <el-header>
                    <navbar />
                </el-header>
                <app-main />
            </el-container>
        </el-container>
    </div>
</template>
<script>
// import RightPanel from '@/components/RightPanel';
import { AppMain, Sidebar, Navbar } from "./components";
import ResizeMixin from './mixin/resize-handler.js';
import { mapGetters } from "vuex";


export default {
    name: "Layout",
    components: {
        AppMain,
        Sidebar,
        Navbar
    },
    mixins: [ResizeMixin],
    computed: {
        ...mapGetters(["sidebar","device"]),
        classObj() {
            return {
                hideSidebar: !this.sidebar.opened,
                openSidebar: this.sidebar.opened,
                // withoutAnimation: this.sidebar.withoutAnimation,
                mobile: this.device === 'mobile',
                sidebarcollapsed: !this.sidebar.opened
            };
        }
    }
};
</script>
